console.info(`${process.env.REACT_APP_NAME}: v${process.env.REACT_APP_VERSION}`)
window.ONSTAR_EXPERIENCE_HUB = {
  createComponent: async (el, data) => {
    const { init } = await import('./createMapComponent.js')
    init(el, data)
  },
}

if (typeof window.mapComponentLoaded === 'function') window.mapComponentLoaded()



// WEBPACK FOOTER //
// ./src/index.js